export function formatDate(dateStr) {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return 'N/A';
  }
}

export function formatCurrency(amount) {
  if (amount == null || isNaN(amount)) return 'PHP 0.00';
  return `PHP ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatPercent(value) {
  if (value == null || isNaN(value)) return '0%';
  return `${Number(value).toFixed(1)}%`;
}

export function getStatusBadgeClass(status) {
  const map = {
    active: 'admin-badge-success',
    inactive: 'admin-badge-danger',
    pending: 'admin-badge-warning',
    approved: 'admin-badge-success',
    suspended: 'admin-badge-danger',
    paid: 'admin-badge-success',
    failed: 'admin-badge-danger',
    player: 'admin-badge-info',
    owner: 'admin-badge-warning',
    admin: 'admin-badge-danger',
  };
  return map[status] || 'admin-badge-neutral';
}
